/*
 * @Author: Dong
 * @Date: 2022-04-07 13:40:11
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-07-03 18:38:43
 */
import { defineMessages } from 'react-intl';

const messageObject: { [propName: string]: string } = {
  welcomeTip: '无运行环境，请创建',
  addEnv: '添加运行环境',
  hasNotNanotube: '选择添加环境的类型',
  nameError: '运行环境名称只能是中文、英文和数字',
  alone: '添加单机环境',
  colony: '添加集群环境',
  envName: '运行环境名称',
  nameNull: '请输入运行环境名称',
  selectEnvType: '选择添加环境的类型',

  viewDetail: '详情',
  delete: '删除',
  confirmDelete: '请确认删除该环境？',
  deletewarning: '无法删除该环境，请先删除该环境下所有主机。',
  aloneText: '单机',
  colonyText: '集群',
  hostStatus: '主机节点运行情况',
  serverStatus: '服务运行情况',
  defaultEnvName: '未命名运行环境',
  init: '正在初始化...',
};

export default defineMessages(messageObject);
